(function ($, document, window, Mobile, Hammer, Navigation, Scrollbar, Fingerprint2, enquire) {
    'use strict';
    
    // jQuery 3.x compatibility shim — restores .success()/.error()/.complete()
    (function ($) {
        if (!$) return;
        
        // Only patch if they're actually missing (i.e. jQuery 3.x+)
        var testXhr = $.Deferred();
        if (typeof testXhr.success === 'undefined') {
            
            // Patch the promise prototype used by $.ajax/$.get/$.post
            var originalAjax = $.ajax;
            
            $.ajax = function () {
                var jqXHR = originalAjax.apply(this, arguments);
                
                jqXHR.success = jqXHR.done;
                jqXHR.error = jqXHR.fail;
                jqXHR.complete = jqXHR.always;
                
                return jqXHR;
            };
        }
    })(jQuery);
    
    $(document).ready(function () {
        var alertHeight = $('.page-notification').innerHeight();
        //jump out from frame
        if (window.top != window.self)
        {
            window.top.location = window.self.location;
        }

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'Access-Control-Allow-Headers': 'x-requested-with',
                'crossDomain': true
            }
        });

        var $userFingerprint = $('meta[name="user-fingerprint"]');

        (new Fingerprint2()).get(function (result) {
            if ($userFingerprint.attr('content') !== result && !$('body').hasClass('page-error')) {
                var url = $userFingerprint.data('url');
                if (!url)
                {
                    return;
                }
                $.post(url, {
                    fingerprint: result
                });
            }
        });

        var
            $body = $('body'),
            $html = $('html');
    
        var $document = $(document);

        if (Mobile.isTouchable()) {
            $body.addClass('touchable');
        }

        $document
            .on('click', '.modal-window', function (e) {
                var url = $(this).attr('href');

                $.get(url).success(function (response) {
                    $(response).modal();
                });

                e.preventDefault();
            })
            .on('click', '.signin-button', function (e) {
                var
                    $form = $(this).closest('form'),
                    $errorContainer = $form.find('.form-signin-messages-container');

                if (!$form.closest('.modal-body').length) {
                    $form[0].submit();
                    return false;
                }

                $.post($form.attr('action'), $form.serialize()).then(function (response) {
                    if (response.error) {
                        $errorContainer.html('<div class="alert alert-danger">' + response.error + '</div>');
                    } else {
                        window.location.reload();
                    }
                });

                e.preventDefault();
            });

        $body.find('input:not(.icheck-input)').iCheck({
            checkboxClass: 'checkbox-styled',
            radioClass: 'radio-styled',
            increaseArea: '40%'
        });

        $('select:not(.phpdebugbar-datasets-switcher)').select2({
            containerCssClass: ':all:',
            width: '100%'
        });

        var $secondaryNavigationDropdowns = $('.secondary-navbar .dropdown');
        var $DropdownCloudBilling = $('.nav-cloud-billing.dropdown');

        $document.on('touchstart', function (e) {
            var $element = $(e.target);

            if (!$element.closest('.dropdown-menu').length && !$element.closest('.dropdown-mobile').length) {
                $secondaryNavigationDropdowns.removeClass('open');
                //$DropdownCloudBilling.removeClass('open');
            }
        });

        $secondaryNavigationDropdowns.hoverIntent({
            sensitivity: 7,
            interval: 50,
            timeout: 0,
            over: function () {
                $(this).addClass('hovered');

                if (!Mobile.isMobileScreenWidth()) {
                    $('.navbar-main > li').removeClass('open');
                }
            },
            out: function () {
                if (!Mobile.isMobileScreenWidth()) {
                    $(this).removeClass('hovered open');
                }
            }
        });

        $DropdownCloudBilling.hoverIntent({
            sensitivity: 7,
            interval: 50,
            timeout: 0,
            over: function () {
                $(this).addClass('hovered');

                if (!Mobile.isTabletScreenWidth()) {
                    $(this).removeClass('open');
                }
            },
            out: function () {
                $(this).removeClass('hovered');
                if (!Mobile.isTabletScreenWidth()) {
                    $(this).removeClass('hovered open');
                }
            }
        });


        // $('.nav-cloud-billing.dropdown').on('show.bs.dropdown', function(e){
        //     $(this).addClass('item-open');

        // });
        // $('.nav-cloud-billing.dropdown').on('hide.bs.dropdown', function(e){
        //     var that = $(this);
        //       that.removeClass('item-open');
        // });

        enquire.register("screen and (max-width: 768px)", {
            match: function () {
                $('.dropdown-mobile').on('show.bs.dropdown', function () {
                    $('body').addClass('no-scroll');
                }).on('hide.bs.dropdown', function () {
                    $('body').removeClass('no-scroll');
                });
            }
        });
        enquire.register("screen and (min-width: 768px)", {
            match: function () {
                $(document).on("click touchend", function (e) {
                    if ($(e.target).closest(".mobile-content > .dropdown").length) {
                        return;
                    }
                    $(".secondary-navbar .dropdown").removeClass("open hovered");
                });
                $('.secondary-navbar .navbar-nav > li,  .dropdown-mobile, .mobile-content > .dropdown').removeClass('open hovered');
                $('body').removeClass('no-scroll');
            }
        });
        enquire.register("screen and (min-width: 992px)", {
            match: function () {
                $DropdownCloudBilling.removeClass("open hovered");
            }
        });

        Navigation.setup();


       /* Scrollbar.setup($(".scroll-list").filter(function(){;
            //return $(this).children('.list-collapse').length === 0;
            return $(this).closest('.product-license').length === 0;
        }));*/

        $document.on('click', '.collapse-item', function(){
            //Scrollbar.update($(this).closest('.scroll-list'));
            //Scrollbar.setup('.scroll-list');
        });

       /* $('.collapse').on('show.bs.collapse', function(){
            Scrollbar.setup('.scroll-list');
        });*/

        Scrollbar.setup('.scroll-list');

        if (Mobile.isTouchable())
        {
            Scrollbar.destroy('.product-license .scroll-list');
            $('.product-license .scroll-list').each(function(){
                var that = $(this);
                var liCounter = $(this).find('li').length;

                if (liCounter > 6){
                    that.addClass('preventScrollBar');
                    that.closest('.tab-pane').addClass('pb-0');
                 }
            });


        }

        $(document).on('cart/runCommand/success', function () {
            //Scrollbar.update('#cart-preview-scrollbar');
            Scrollbar.resize();
        });

        
        $('#choose-page').click(function (e) {
            var activeNode = Navigation.getActiveNode();

            if (activeNode && activeNode.getUrl()) {
                window.location.href = activeNode.getUrl();
            }

            e.preventDefault();
        });

        $('img.lazy').lazyload({
            effect: 'fadeIn'
        });

        if (Mobile.registered()) {
            var
                mc = new Hammer(document.getElementById('page-wrapper')),
                nt = new Hammer(document.getElementById('navbar-toggle'));

            var slider = $('.lightSlider, .flickity-enabled, .hammer-ignore');
            var timeline = $('.section-timeline');
            var tabs = $('.tabs');
            var newSliders = $('.new-banner-slider','.update-slider','.testimmonials-slider','partners-boxes.lightSlider','news-slider');
            mc.on("swiperight", function (e) {
                var slider = $('.lightSlider, .flickity-enabled, .hammer-ignore');
                if (slider.is(e.target) || slider.has(e.target).length || timeline.is(e.target) || timeline.has(e.target).length || tabs.is(e.target) || tabs.has(e.target).length ) {

                } else {
                    $body.addClass('main-menu-open');
                    $html.addClass('no-scroll');
                }
            });

            mc.on("swipeleft", function () {
                $body.removeClass('main-menu-open');
                $html.removeClass('no-scroll');
            });

            var pageLoaded = false;

            $(window).on('load', function() {
                setTimeout(function () {
                    pageLoaded = true;
                }, 500);
            });

            nt.on("tap", function () {
                if (!pageLoaded) return;

                $body.toggleClass('main-menu-open');
                $html.toggleClass('no-scroll');
            });
        } else {
            $document.on('click', '.navbar-toggle', function () {
                if (!$body.hasClass('main-menu-open')) {
                    $body.addClass('main-menu-open no-scroll');
                } else {
                    $body.removeClass('main-menu-open');
                    setTimeout(function () {
                        $body.removeClass('no-scroll');
                    }, 500);
                }
            });
        }
        if (Mobile.isTouchable()) {
           $('[data-toggle="tooltip"]').tooltip();
        } else {
            $body.tooltip({
                selector: '[data-toggle="tooltip"]',
                trigger: 'hover'
            });
        }
        
        var $cartPreviewDropdown = $('#cart-preview-dropdown');
        var $cartButton = $('.secondary-navbar .btn-circle');

        if (Mobile.isTouchable()) {
            $document.on('click', '#cart-preview', function (e) {
                e.preventDefault();
                $cartPreviewDropdown.toggleClass('open');
                $cartButton.toggleClass('active');
            });
        } else {
            $document.on('mouseover', '#cart-preview', function () {
                $cartPreviewDropdown.addClass('open');
                $cartButton.addClass('active');
            }).on('mouseout', '#cart-preview', function () {
                $cartPreviewDropdown.removeClass('open');
                $cartButton.removeClass('active');
            });
            $document.on('click', '#cart-preview > .btn', function () {
                if (Cart.isEmpty()) {
                    return false;
                }
            });
        }

        var $cartMobilePreviewDropdown = $('#mobile-cart-preview-dropdown');

        $document.on('click', '#mobile-cart-preview > a', function (e) {
            e.preventDefault();
            $cartMobilePreviewDropdown.toggleClass('open');
        });

        $document.on('click touchstart', function (e) {
            if (!$('.btn-circle', '#cart-preview').has(e.target).length) {
                $cartPreviewDropdown.removeClass('open');
                $('.secondary-navbar .btn-circle').removeClass('active');
            }
        });
        
        $document.on('click touchstart', function (e) {
            if(!$(e.target).closest('#mobile-cart-preview').length) {
                if($('#mobile-cart-preview-dropdown').is(":visible")) {
                    $('#mobile-cart-preview-dropdown').removeClass('open');
                }
            }
        });

        $('.list-collapse .active .item-body').css('display', 'block');

        $document.on('click', '.collapse-item-anchor', function (e) {
            e.preventDefault();
            var $this = $(this);

            if ($this.parent().hasClass('active')) {
                $this.parent().removeClass('active');
                $this.siblings('.item-body').slideUp(250, function(){
                    if (!Mobile.isTouchable())
                    {
                        Scrollbar.resize();
                    }
                });
                if ($this.parent().parent().hasClass('list-lg')) {
                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: $this.parent().offset().top - 250
                        }, 50);
                    }, 200);
                }
            } else {
                $this.closest('ul').find('.active').removeClass('active').children('.item-body').slideUp(250);
                $this.parent().addClass('active');
                $this.siblings('.item-body').slideDown(250, function(){
                    if (!Mobile.isTouchable())
                    {
                        Scrollbar.resize();
                    }
                });
                if ($this.parent().parent().hasClass('list-lg')) {
                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: $this.parent().offset().top - 250
                        }, 50);
                    }, 200);
                }
            }
        });

         $(window).on('load resize', function () {
            var
                $secondaryNavbar = $('body:not(.page-order, .page-clientarea) .secondary-navbar'),
                $secondaryNavbarCa = $('body.page-clientarea .secondary-navbar'),
                $primaryNavbar = $('body:not(.marketplace-page, .page-clientarea) .primary-navbar, .page-filename-submitticket.page-notlogged .primary-navbar'),
                $mobileHeader = $('.mobile-header');
                var promoBanner = $('.promo-banner');


            enquire.register("screen and (max-width: 991.98px)", {
                match: function () {
                    $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                    $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                    $primaryNavbar.removeData('bs.affix').removeClass('affix');
                    $mobileHeader.removeData('bs.affix').removeClass('affix');
                    /* old sticky header
                    $mobileHeader.affix({
                        offset: {
                            top: 32
                        }
                    });
                    */
                }
            });

            enquire.register("screen and (min-width: 1200px)", {
                match: function () {
                    $(window).off('.affix')
                    $mobileHeader.removeData('bs.affix').removeClass('affix');
                    $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                    $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                    $primaryNavbar.removeData('bs.affix').removeClass('affix');
                    if (promoBanner.length){
                        $secondaryNavbarCa.affix({
                            offset: {
                                top: 196
                            }
                        });
                    }
                    else{
                        $secondaryNavbarCa.affix({
                            offset: {
                                top: 116
                            }
                        });
                    }


                    $secondaryNavbar.affix({
                        offset: {
                            top: 148
                        }
                    });

                    $primaryNavbar.affix({
                        offset: {
                            top: 64
                        }
                    });
                }
            });
            enquire.register("screen and (min-width: 992px) and (max-width: 1200px)", {
                match: function () {
                    $(window).off('.affix')
                    $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                    $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                    $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                    $primaryNavbar.removeData('bs.affix').removeClass('affix');
                    $mobileHeader.removeData('bs.affix').removeClass('affix');
                    if (promoBanner.length){
                        $secondaryNavbarCa.affix({
                            offset: {
                                top: 228
                            }
                        });
                    }
                    else{
                        $secondaryNavbarCa.affix({
                            offset: {
                                top: 116
                            }
                        });
                    }

                    $secondaryNavbar.affix({
                        offset: {
                            top: 148
                        }
                    });
                    $primaryNavbar.affix({
                        offset: {
                            top: 64
                        }
                    });
                }
            });
        });
        enquire.register("screen and (min-width: 768px)", {
            match: function () {
                $(document).on("click touchend", function (e) {
                    if ($(e.target).closest(".mobile-content > .dropdown").length) {
                        return;
                    }
                    $(".secondary-navbar .dropdown").removeClass("open hovered");
                });
                $('.secondary-navbar .navbar-nav > li,  .dropdown-mobile, .mobile-content > .dropdown').removeClass('open hovered');
                $('body').removeClass('no-scroll');
            }
        });

        $(document).on('navigation.category.clicked', function (e, node) {
            if (Mobile.isTouchable() && node.hasCategories() && node.isRoot()) {
                node.select();
                return false;
            } else if (Mobile.isMobileScreenWidth()) {
                node.select();
                return false;
            } else {
                window.location.href = node.getUrl();
            }
        });

        $('.modal').each(function () {
            $('body').append(this);
        });


        $('.tab-pane .read-more').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.tab-pane').addClass('expanded');
        });

        if ($('.section-anchor').length){
            $('.section-anchor').each(function(){
                var that = $(this);
                var navbarFirstHeight = parseFloat($('.primary-navbar').outerHeight()).toFixed(0);
                var marginTop = $(this).css('margin-top')
                var marginBottom = $(this).css('margin-bottom')

                if (window.matchMedia("(max-width: 991px)").matches) {
                    navbarFirstHeight = parseFloat($('.mobile-header').outerHeight()).toFixed(0);
                }

                marginTop = parseInt(marginTop) - parseInt(navbarFirstHeight);
                marginBottom = parseInt(marginBottom) + parseInt(navbarFirstHeight);

                that.css('margin-top', marginTop+'px');
                that.css('margin-bottom', marginBottom+'px');
            })
        }

        /*
            Tabs
        */
        
        // Swpie Tabs
        var sliderArray = {};
        function tabslider() {
            var counter = 0;

            $('.nav-tabs-slide').each(function () {
                var sliderwidth = 0;
                var containerWidth = $(this).closest('.tabs').outerWidth();
                counter += 1;
                
                $(this).attr('id', 'tabs-'+counter)
                //mseure tabs width
                $(this).find('>li').each(function () {
                    sliderwidth += $(this).outerWidth(true);
                });
                 if (typeof sliderArray["slider"+counter] === 'undefined' || !sliderArray["slider"+counter]) {
                        sliderArray["slider"+counter] = 0;
                    }
                //create slider
                if (sliderwidth > containerWidth) {
                    if ((!sliderArray["slider"+counter].lightSlider)) {
                        sliderArray["slider"+counter] = $(this).lightSlider({
                            autoWidth: true,
                            pager: false,
                            controls: false,
                            slideMargin: 0,
                            freeMove: false
                        });
                    }
                }
                else {
                    if (sliderArray["slider"+counter] != 0) {
                        sliderArray["slider"+counter].destroy();
                    }
                }
                //Slide to element on tab change
                $(this).find('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
                    var tabIndex = $(e.target).parent().index();
                    var tabsIndex = $(e.target).closest('.nav-tabs-slide').attr('id').replace('tabs-', '');
                    if (sliderArray["slider"+tabsIndex] != 0) {
                        sliderArray["slider"+tabsIndex].goToSlide(tabIndex);
                    }
                });
                //Slide to element on window load or resize
                if (sliderArray["slider"+counter] != 0) {
                    sliderArray["slider"+counter].goToSlide($(this).find('li.active').index());
                }
            });
        }
        $(window).on('load resize', function () {
             setTimeout(function () {
                tabslider();
            }, 500);
        })

        // Change tab on has change
        $(window).on('load', function(){
            var context = $('.nav-tabs, .btn-tab, .product-features-collapsible-list a');
            var prefix = "#tab-";
            var settings = $.extend({
                getHashCallback: function (hash) {
                    return hash;
                }
            });
            $('a', context).on('click', function () {
                var hash = this.hash.replace(prefix, "#");
                window.location.hash = settings.getHashCallback(hash);
            });
            var showTabFromHash = function () {
                var
                    hash = window.location.hash,
                    selector = hash ? ('a[href="' + hash.replace("#", prefix) + '"]') : 'li:first-child > a',
                    $matches = $(selector, context),
                    $object = $matches.filter(':visible').first();
                if (!$object.length) {
                    $object = $matches.first();
                }
                var $tabPane = $object.closest('.tab-pane');
                if (!hash) {
                    return;
                }

                if( $tabPane.length) {
                    $('a[href="#' + $tabPane.attr('id') + '"]').tab('show');
                }

                if($object.is(':visible'))
                {
                    $object.tab('show');
                }
            };
            if (window.location.hash) {
                showTabFromHash(context);
            }
            $(window).on('hashchange', showTabFromHash);

            $('.product-features-collapsible-list a').on('click', function(){
                if($(this).attr('href').indexOf('#') > 0)
                {
                    var id  = $(this).attr('href').substring($(this).attr('href').indexOf('#')+1);
                    $('html, body').animate({
                        scrollTop: $('a[href="'+prefix+id+'"]').closest('.tabs').offset().top-72
                    }, 300);
                }
            });
        });

        /* 
            Sidebar
        */
        
        var $contentSidebar = $('.content-sidebar:not("#category-sidebar")');

        enquire.register("screen and (min-width: 992px)", {
            match: function () {

                $contentSidebar.stick_in_parent({
                    offset_top: 16
                });
                $contentSidebar
                    .on('sticky_kit:bottom', function () {
                        $(this).parent().css('position', 'static');
                    })
                    .on('sticky_kit:unbottom', function () {
                        $(this).parent().css('position', 'relative');
                    });

                $('.payment-method-label').on('click', function () {
                    $('.tab-payment-method .tab-pane').removeClass('active');
                    $(this).closest('.tab-pane').addClass('active');
                });

            },
            unmatch: function () {
                $contentSidebar.trigger("sticky_kit:detach");
            }
        });

        function caDropdownAttr() {
            var caLink = $('.ca-dropdown .link-ca');

            enquire.register("screen and (min-width: 992px)", {
                match: function () {
                    caLink.removeAttr('data-toggle');
                }
            });
            enquire.register("screen and (max-width: 991px)", {
                match: function () {
                    caLink.attr('data-toggle', 'dropdown');
                }
            });
        }

        caDropdownAttr();

        $(window).on('resize', function () {
            caDropdownAttr();
        });

        $('.widget-body h3 a').hover(function () {
            $(this).closest('.widget').find('.widget-header').toggleClass("hovered");
        });

        (function () {
            var
                $scrollTop = $('#scroll-top'),
                windowHeight = 1.5 * parseInt($(window).height());

            $(window).scroll(function () {
                if ($(window).scrollTop() > windowHeight) {
                    $scrollTop.fadeIn();
                } else {
                    $scrollTop.fadeOut();
                }
            });

            $scrollTop.on('click', function () {
                $('html, body').animate({
                    scrollTop: 0
                }, 600);

                return false;
            });
        })();

        (function () {
            var $backButton = $('#error-page-back-btn');

            function isMarketPlace() {
                return window.location.pathname.startsWith('/products/');
            }

            function isClientArea() {
                return window.location.pathname.startsWith('/client-area/');
            }

            function isSupport() {
                return window.location.pathname.startsWith('/support/');
            }

            $backButton.removeClass('hidden').click(function (e) {
                if (document.referrer.indexOf(window.location.host) !== -1) {
                    history.go(-1);
                } else if (isSupport()) {
                    window.location.href = window.location.origin + '/support';
                } else if (isMarketPlace()) {
                    window.location.href = window.location.origin + '/products/';
                } else if (isClientArea()) {
                    window.location.href = window.location.origin + '/client-area/';
                } else {
                    window.location.href = window.location.origin;
                }

                e.preventDefault();
            });
        })();
        

        var multiAlert = {

            init: function () {
                var that = this;
                //default status
                var status = false;
                $.ajax({
                    cache: false,
                    url: "/products/build/assets/json/notification.json?v="+Math.random(),
                    dataType: "json",
                    success: function(data){
                        if(data.status && data.id && Cookies.get('siteAlert') !== data.id.toString()) {
                            status = data.status;
                        }
                        if(data['expires-on'])
                        {
                            var d = data['expires-on'];
                            var timestamp           = Date.parse(d.split(' ')[0]+'T'+d.split(' ')[1]+'Z');
                            var currentTimestamp    = new Date().getTime();
                            
                            
                            // console.log(timestamp, currentTimestamp, (data['expires-on'] + ' GMT').replace(/-/g, ' '));
                            if(timestamp < currentTimestamp || Number.isNaN(timestamp))
                            {
                                status = 0;
                            }
                        }
                        if (status) {
                            that.functions();
                        }
                        else {
                            that.removeAlert();
                        }
                    }
                });
            },
            functions: function () {
                this.getContent();
                /* old sticky header
                this.resizeContent();
                */
                $('.page-notification [data-action="close"]').on('click', this.closeAlert.bind(this));
            },
            getContent: function () {
               
                var that = this;
                $('body').addClass('scrolled-top');
                $.getJSON("/products/build/assets/json/notification.json?v="+Math.random(), function (data) {
                    var length = data.msg.length;

                    if (data.status && length > 0) {
                        for (var i = 0; i < length; i++) {
                            var msg = data.msg[i];

                            if (msg.visible) {
                                that.createContent(msg.content || '');
                            }
                        }
                        setTimeout(function () {
                            /* old sticky header
                            that.setTop();
                            that.showAlert();
                            */
                            that.revealAlert();
                            convertTimers();
                        }, 1500);

                    }
                });
            },
            revealAlert: function () {
                var $notification = $('.page-notification');
                if (!$notification.length) {
                    return;
                }

                this.alertDismissed = false;
                this.updateNotifHeight();
                $('body').addClass('mg-has-notification');

                $notification[0].offsetHeight;
                $notification.addClass('is-visible');

                var that = this;
                requestAnimationFrame(function () {
                    that.updateNotifHeight();
                });
                $(window).off('resize.mgNotifHeader').on('resize.mgNotifHeader', function () {
                    that.updateNotifHeight();
                });
                this.bindScrollHide();
            },
            updateNotifHeight: function () {
                var height = Math.round($('.page-notification').outerHeight() || 0);
                if (height < 1) {
                    height = 64;
                }
                document.documentElement.style.setProperty('--mg-notif-h', height + 'px');
            },
            bindScrollHide: function () {
                var that = this;
                var leftTop = false;
                var instantCss = {
                    'transition': 'none',
                    '-webkit-transition': 'none'
                };

                function applyInstant($notification, fn) {
                    var $header = $('.mobile-header');
                    $notification.css(instantCss);
                    $header.css(instantCss);
                    fn();
                    if ($notification[0]) {
                        $notification[0].offsetHeight;
                    }
                    if ($header[0]) {
                        $header[0].offsetHeight;
                    }
                    $notification.css({
                        'transition': '',
                        '-webkit-transition': ''
                    });
                    $header.css({
                        'transition': '',
                        '-webkit-transition': ''
                    });
                }

                function apply() {
                    if (that.alertDismissed) {
                        return;
                    }
                    var $notification = $('.page-notification');
                    if (!$notification.length) {
                        return;
                    }
                    var threshold = Math.round($notification.outerHeight() || 0) || 64;
                    var atTop = $(window).scrollTop() <= threshold;

                    if (atTop) {
                        if (!leftTop) {
                            return;
                        }
                        applyInstant($notification, function () {
                            $notification.addClass('is-visible');
                            $('body').addClass('mg-has-notification');
                        });
                    } else {
                        leftTop = true;
                        applyInstant($notification, function () {
                            $notification.removeClass('is-visible');
                            $('body').removeClass('mg-has-notification');
                        });
                    }
                }

                $(window).off('scroll.mgNotifHide').on('scroll.mgNotifHide', apply);
                apply();
            },
            unbindScrollHide: function () {
                this.alertDismissed = true;
                $(window).off('scroll.mgNotifHide');
            },
            /* old sticky header
            setTop: function () {
                var alertheight = parseFloat($('.page-notification').outerHeight()).toFixed(0);

                $('.page-notification').css('top', -(alertheight));
            },
            showAlert: function () {
                var alertheight = parseFloat($('.page-notification').outerHeight()).toFixed(0);
                var mobileHeaderHeight = parseFloat($('.mobile-header').outerHeight()).toFixed(0);
                var navbarHeight = parseFloat($('.primary-navbar').outerHeight()).toFixed(0);
                var $primaryNavbar = $('body:not(.marketplace-page, .page-clientarea) .primary-navbar, .page-filename-submitticket.page-notlogged .primary-navbar');
                var $secondaryNavbar = $('body:not(.page-order, .page-clientarea) .secondary-navbar'),
                $mobileHeader = $('.mobile-header'),
                $secondaryNavbarCa = $('body.page-clientarea .secondary-navbar'),
                promoBanner = $('.promo-banner');


                if ($('.page-notification').outerHeight() !== null) {

                    if ($('.section-anchor').length){
                        if (window.matchMedia("(min-width: 991px)").matches) {
                            $('html, body').animate({
                                scrollTop: window.scrollY - alertheight,
                            }),500;
                        }
                    }
                    if ($('.section-anchor').length){
                        $('.section-anchor').each(function(){
                            var that = $(this);
                            var navbarFirstHeight = parseFloat($('.primary-navbar').outerHeight()).toFixed(0);
                            var marginTop = $(this).css('margin-top')
                            var marginBottom = $(this).css('margin-bottom')
            
                            if (window.matchMedia("(max-width: 991px)").matches) {
                                navbarFirstHeight = parseFloat($('.mobile-header').outerHeight()).toFixed(0);
                            }
            
                            marginTop = parseInt(marginTop) - parseInt(alertheight);
                            marginBottom = parseInt(marginBottom) + parseInt(alertheight);
            
                            that.css('margin-top', marginTop+'px');
                            that.css('margin-bottom', marginBottom+'px');
                        })
                    }
                    

                    var notificationAnimated = false;
                    var mobileHeaderAnimated = false;
                    var desktopHeaderAnimated = false;
                    var pageHeaderFixed = false;

                    function updatePositionsImmediate() {
                        var windowWidth = $(window).outerWidth(true);
                        var alertHeight = $('.page-notification').length ? $('.page-notification').outerHeight(true) : 0;

                        var marginTop, marginBottom;
                        if ($('.page-notification').length) {
                            marginTop = alertHeight + parseInt(navbarHeight) - 32;
                            marginBottom = -(alertHeight + parseInt(navbarHeight) - 32);
                        } else {
                            marginTop = alertHeight + parseInt(navbarHeight);
                            marginBottom = -(alertHeight + parseInt(navbarHeight));
                        }

                        if (windowWidth >= 991.98) {
                            $('.promo-banner').stop(true, true).animate({
                                'margin-top': marginTop,
                                'margin-bottom': marginBottom
                        }, 500);

                            var primaryTop = 0;
                            if ($('.page-notification').length) {
                                primaryTop = alertHeight;
                                if ($('.page-navbar').hasClass('affix-top')) primaryTop += 32;
                            } else if ($('.page-navbar').hasClass('affix-top')) {
                                primaryTop = 64;
                            }

                            
                            var scrollTop = $(window).scrollTop();


                            if(!desktopHeaderAnimated) {
                            $primaryNavbar.stop(true, true).animate({ top: primaryTop }, 700, "linear").addClass('is-fixed');
                                desktopHeaderAnimated = true;
                            } else {
                                $primaryNavbar.css({ top: primaryTop }, 700);
                                if (!($('.page-notification').length)) {
                                    if(scrollTop < 64) {
                                        $primaryNavbar.removeClass('is-fixed');
                                        $primaryNavbar.css({ top: 32 }, 700)
                                    }
                                    else {
                                        $primaryNavbar.addClass('is-fixed');
                                        $primaryNavbar.css({ top: 0 }, 700)
                                        $(window).trigger('scroll');
                                    }
                                }
                            }

                            if (!pageHeaderFixed) {
                            $('.page-header').stop(true, true).animate({ top: alertHeight - 32 }, 500);
                                pageHeaderFixed = true;
                            }
                            $('#category-sidebar').stop(true, true).animate({ 'padding-top': alertHeight }, 500);
                            $('#category-sidebar .filter:last-of-type').stop(true, true).animate({ 'margin-bottom': alertHeight + 16 }, 500);
                            $('.secondary-navbar').stop(true, true).animate({ top: alertHeight }, 500);
                        $('#order-cart-summary').trigger("sticky_kit:detach").addClass('is-sticky');
                            $('#order-cart-summary').stop(true, true).animate({ top: alertHeight + 16 }, 500);

                            if ($('.page-notification').length) {
                                var notifTop;
                                if ($('body').hasClass('page-notlogged')) {
                                    notifTop = $(window).scrollTop() >= 32 ? 0 : 32;
                                } else {
                                    notifTop = $('.page-navbar').hasClass('affix-top') ? 32 : 0;
                                }

                                    var topBanner = $('.top-banner');
    
                                if ($('body').hasClass('page-login')) {
                                    topBanner.css({ position: 'sticky' });

                                    function updateTopBanner() {
                                        if ($(window).scrollTop() >= 32) {
                                            topBanner.css({ top: -32 });
                                        } else {
                                            topBanner.css({ top: 0 });
                                        }
                                    }

                                    updateTopBanner();

                                    $(window).on('scroll', updateTopBanner);
                                } else {
                                    if ($('.page-navbar').hasClass('affix-top')) {
                                        topBanner.css({ position: 'sticky', top: 0 });
                                    } else {
                                        topBanner.css({ position: 'sticky', top: -32 });
                                    }
                                }
                                
                                if (!notificationAnimated) {
                                    $('.page-notification').stop(true, true).animate({ top: notifTop }, 550, "linear");
                                    notificationAnimated = true;
                                } else {
                                    $('.page-notification').css({ top: notifTop });
                                }
                            }
                        }
                        else {
                            var marginTopMobile, marginBottomMobile;

                            if ($('.page-notification').length) {
                                marginTopMobile = alertHeight + parseInt(mobileHeaderHeight);
                                marginBottomMobile = -(alertHeight + parseInt(mobileHeaderHeight));
                            } else {
                                marginTopMobile = alertHeight + parseInt(mobileHeaderHeight);
                                marginBottomMobile = -(alertHeight + parseInt(mobileHeaderHeight));
                            }

                            $('.promo-banner').stop(true, true).animate({
                                'margin-top': marginTopMobile,
                                'margin-bottom': marginBottomMobile
                        }, 500);

                            $('#category-sidebar').stop(true, true).animate({ 'padding-top': alertHeight + 16 }, 500);
                            $('#category-sidebar .filter:last-of-type').stop(true, true).animate({ 'margin-bottom': alertHeight + 16 }, 500);
                            $('.page-header').stop(true, true).animate({ 'padding-top': alertHeight + 32 }, 500);
                            $('.secondary-navbar .dropdown-mobile .mobile-content').stop(true, true).animate({ top: alertHeight + parseInt(mobileHeaderHeight) + 48 }, 500);

                            if ($('.page-notification').length) {
                                var notifTop = $('.mobile-header').hasClass('affix-top') ? 32 : 0;
                                if (!notificationAnimated) {
                                    $('.page-notification').stop(true, true).animate({ top: notifTop }, 580, "linear");
                                    notificationAnimated = true;
                                } else {
                                    $('.page-notification').css({ top: notifTop });
                                }
                            }

                            var topBanner = $('.top-banner');

                                if ($('body')) {
                                    topBanner.css({ position: 'sticky' });

                                    function updateTopBanner() {
                                        if ($(window).scrollTop() >= 32) {
                                            topBanner.css({ top: -32 });
                                        } else {
                                            topBanner.css({ top: 0 });
                                        }
                                    }

                                    updateTopBanner();

                                    $(window).on('scroll', updateTopBanner);
                                } else {
                                    if ($('.page-navbar').hasClass('affix-top')) {
                                        topBanner.css({ position: 'sticky', top: 0 });
                                    } else {
                                        topBanner.css({ position: 'sticky', top: -32 });
                                    }
                                }
                        }

                        var mobileTop = 0;
                        if ($('.mobile-header').hasClass('affix')) {
                            mobileTop = $('.page-notification').length ? alertHeight : 0;
                        } else if ($('.mobile-header').hasClass('affix-top')) {
                            mobileTop = $('.page-notification').length ? alertHeight + 32 : 32;
                        } else {
                            mobileTop = alertHeight;
                        }
                        
                        if (!mobileHeaderAnimated) {
                            $('.mobile-header').stop(true, true).animate({position: 'fixed', top: mobileTop }, 700);
                            mobileHeaderAnimated = true;
                        } else {
                            $('.mobile-header').css({position: 'fixed', top: mobileTop });
                    }
                    }

                    var invertalPageNotification;
                    var isInited = false;

                    function checkSecondaryNavbar() {
                        var $secondary = $('.secondary-navbar');

                        if ($secondary.hasClass('affix-top')) {
                            isInited = true;
                            return;
                        }

                        if ($secondary.hasClass('affix') && !isInited) {
                            setTimeout(function() {
                                isInited = true;
                            }, 500);
                        }
                    }

                    checkSecondaryNavbar();

                    $(window).on('scroll resize', function () {
                        var scrollTop = $(window).scrollTop();
                        var isDesktop = window.innerWidth >= 991.98;

                        checkSecondaryNavbar();

                        if (isDesktop && scrollTop >= 64) {
                            if ($primaryNavbar.hasClass('affix-top')) {
                                window.requestAnimationFrame(updatePositionsImmediate);
                            } else {
                                if (!isInited) {
                                clearTimeout(invertalPageNotification);
                                invertalPageNotification = setTimeout(function() {
                        window.requestAnimationFrame(updatePositionsImmediate);
                                }, 500);
                                } else {
                                    window.requestAnimationFrame(updatePositionsImmediate);
                                }
                            }
                        } else {
                            window.requestAnimationFrame(updatePositionsImmediate);
                        }
                    });

                    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                        setTimeout(updatePositionsImmediate, 50);
                    } else {
                    updatePositionsImmediate();
                    }



                    enquire.register("screen and (min-width: 1200px)", {
                        match: function () {
                            $(window).off('.affix')

                            if ($secondaryNavbarCa.length){
                                $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                            }
                            if ($secondaryNavbar.length){
                                $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                            }
                            if ($primaryNavbar.length){
                                $primaryNavbar.removeData('bs.affix').removeClass('affix');
                            }
                            if ($mobileHeader.length){
                                $mobileHeader.removeData('bs.affix').removeClass('affix');
                            }
                            if ($secondaryNavbarCa.length){
                                if (promoBanner.length){
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 190
                                        }
                                    });
                                }
                                else{
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 86
                                        }
                                    });
                                }
                            }

                            if ($secondaryNavbar.length){
                                $secondaryNavbar.affix({
                                    offset: {
                                        top: 144
                                    }
                                });
                            }
                            if ($primaryNavbar.length){
                                $primaryNavbar.affix({
                                    offset: {
                                        top: 32
                                    }
                                });
                            }
                        }

                    });
                    enquire.register("screen and (min-width: 992px) and (max-width: 1200px)", {
                        match: function () {
                            $(window).off('.affix')
                            if ($secondaryNavbarCa.length){
                                $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                            }
                            if ($secondaryNavbar.length){
                                $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                            }
                            if ($primaryNavbar.length){
                                $primaryNavbar.removeData('bs.affix').removeClass('affix');
                            }
                            if ($mobileHeader.length){
                                $mobileHeader.removeData('bs.affix').removeClass('affix');
                            }
                            if ($secondaryNavbarCa.length){
                                if (promoBanner.length){
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 162
                                        }
                                    });
                                }
                                else{
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 86
                                        }
                                    });
                                }
                                if ($secondaryNavbar.length){
                                    $secondaryNavbar.affix({
                                        offset: {
                                            top: 86
                                        }
                                    });
                                }
                                if ($primaryNavbar.length){
                                    $primaryNavbar.affix({
                                        offset: {
                                            top: 32
                                        }
                                    });
                                }
                            }
                        }
                    });
                
                }
                if ($('.page-notification').outerHeight() !== null) {
                    var baseMargin;
                    if (parseFloat($(window).outerWidth(true)) >= 991.98) {
                        baseMargin = parseInt(alertheight) + parseInt(navbarHeight) - 32;
                        if ($('.page-navbar').hasClass('affix')) {
                            if($(".home-page-new")) {
                            baseMargin += 16;
                            }
                            if($(".marketplace-page")) {
                                baseMargin -= 16;
                            }
                        } else if ($('.page-navbar').hasClass('affix-top')) {
                        
                        }
                    } else {
                        baseMargin = parseInt(alertheight) + parseInt(mobileHeaderHeight);
                    }
                        $('.page-wrapper').animate({
                        'margin-top': baseMargin
                    }, 700);
                }
            },
            
            */

            createContent: function (content) {
                $('.page-notification .notification-body').append(content || '');
            },
            /* old sticky header
            resizeContent: function () {
                var that = this;
                $(window).on('resize', function () {
                        var alertheight = parseFloat($('.page-notification').outerHeight()).toFixed(0);
                        var mobileHeaderHeight = parseFloat($('.mobile-header').outerHeight()).toFixed(0);
                        var navbarHeight = parseFloat($('.primary-navbar').outerHeight()).toFixed(0);
                        var $primaryNavbar = $('body:not(.marketplace-page, .page-clientarea) .primary-navbar, .page-filename-submitticket.page-notlogged .primary-navbar');

                        var $secondaryNavbar = $('body:not(.page-order, .page-clientarea) .secondary-navbar'),
                        $secondaryNavbarCa = $('body.page-clientarea .secondary-navbar'),
                        $mobileHeader = $('.mobile-header'),
                        promoBanner = $('.promo-banner');
                        if ($('.page-notification').outerHeight() !== null && $('.page-notification').length) {
                            if ($('.section-anchor').length){
                                $('.section-anchor').each(function(){
                                    var that = $(this);
                                    var navbarFirstHeight = parseFloat($('.primary-navbar').outerHeight()).toFixed(0);
                                    var marginTop = -40
                                    var marginBottom = 40
                    
                                    if (window.matchMedia("(max-width: 991px)").matches) {
                                        navbarFirstHeight = parseFloat($('.mobile-header').outerHeight()).toFixed(0);
                                    }
                    
                                    marginTop = parseInt(marginTop) - parseInt(navbarFirstHeight) - parseInt(alertheight);
                                    marginBottom = parseInt(marginBottom) + parseInt(navbarFirstHeight) + parseInt(alertheight);

                    
                                    that.css('margin-top', marginTop+'px');
                                    that.css('margin-bottom', marginBottom+'px');
                                })
                            }
                            if (parseFloat($(window).outerWidth(true)) >= 991.98) {
                                    $('.page-header').animate({
                                        'top': alertheight - 32
                                    }, 0);
                                    $primaryNavbar.animate({
                                        'top': alertheight
                                    }, 0).addClass('is-fixed');
                                    $('.promo-banner').animate({
                                        'margin-top': parseInt(alertheight) + parseInt(navbarHeight) - 32,
                                        'margin-bottom': - (parseInt(alertheight) + parseInt(navbarHeight) - 32),
                                    }, 0);
                                    $('.page-notification').animate({
                                        'top': 0
                                    }, 0);
                                    $('#category-sidebar').animate({
                                        'padding-top': alertheight
                                    });
                                    $('#category-sidebar .filter:last-of-type').animate({
                                        'margin-bottom': parseInt(alertheight) + 16
                                    });
                                    $('.secondary-navbar').css({
                                        'top': alertheight + "px"
                                    });
                                    $('#order-cart-summary').trigger("sticky_kit:detach").addClass('is-sticky');
                                    $('#order-cart-summary').animate({
                                        'top': parseInt(alertheight) + 16
                                    }, 0);
                                }
                                else{
                                    $('.promo-banner').animate({
                                        'margin-top': parseInt(alertheight) + parseInt(mobileHeaderHeight),
                                        'margin-bottom': - (parseInt(alertheight) + parseInt(mobileHeaderHeight)),
                                    }, 0);
                                    $('.mobile-header').animate({
                                        'top': alertheight
                                    }, 0);
                                    $('.page-notification').animate({
                                        'top': 0
                                    }, 0);
                                    $('.page-header').animate({
                                        'padding-top': (parseInt(alertheight) + 12)
                                    }, 0);
                                    $('#category-sidebar').animate({
                                        'padding-top': parseInt(alertheight) + 16
                                    });
                                    $('#category-sidebar .filter:last-of-type').animate({
                                        'margin-bottom': parseInt(alertheight) + 16
                                    });
                                    $('.secondary-navbar .dropdown-mobile .mobile-content').css({'top': parseInt(alertheight) + parseInt(mobileHeaderHeight) + 48});
                                }
                            if (parseFloat($(window).outerWidth(true)) >= 991.98) {
                                $('.page-wrapper').animate({
                                    'margin-top': parseInt(alertheight) + parseInt(navbarHeight) - 32
                                }, 0);
                            }
                            else
                                {
                                    $('.page-wrapper').animate({
                                        'margin-top': parseInt(alertheight)+ parseInt(mobileHeaderHeight),
                                    }, 0);

                                }
                                enquire.register("screen and (min-width: 1200px)", {
                                    match: function () {
                                        $(window).off('.affix')

                                        if ($secondaryNavbarCa.length){
                                            $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                                        }
                                        if ($secondaryNavbar.length){
                                            $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                                        }
                                        if ($primaryNavbar.length){
                                            $primaryNavbar.removeData('bs.affix').removeClass('affix');
                                        }
                                        if ($mobileHeader.length){
                                            $mobileHeader.removeData('bs.affix').removeClass('affix');
                                        }
                                        if ($secondaryNavbarCa.length){
                                            if (promoBanner.length){
                                                $secondaryNavbarCa.affix({
                                                    offset: {
                                                        top: 132
                                                    }
                                                });
                                            }
                                            else{
                                                $secondaryNavbarCa.affix({
                                                    offset: {
                                                        top: 86
                                                    }
                                                });
                                            }
                                        }
                                        if ($secondaryNavbar.length){
                                            $secondaryNavbar.affix({
                                                offset: {
                                                    top: 86
                                                }
                                            });
                                        }
                                        if ($primaryNavbar.length){
                                            $primaryNavbar.affix({
                                                offset: {
                                                    top: 32
                                                }
                                            });
                                        }

                                    }
                                });
                                enquire.register("screen and (min-width: 992px) and (max-width: 1200px)", {
                                    match: function () {
                                        $(window).off('.affix')
                                        if ($secondaryNavbarCa.length){
                                            $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                                        }
                                        if ($secondaryNavbar.length){
                                            $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                                        }
                                        if ($primaryNavbar.length){
                                            $primaryNavbar.removeData('bs.affix').removeClass('affix');
                                        }
                                        if ($mobileHeader.length){
                                            $mobileHeader.removeData('bs.affix').removeClass('affix');
                                        }
                                        if ($secondaryNavbarCa.length){
                                            if (promoBanner.length){
                                                $secondaryNavbarCa.affix({
                                                    offset: {
                                                        top: 162
                                                    }
                                                });
                                            }
                                            else{
                                                $secondaryNavbarCa.affix({
                                                    offset: {
                                                        top: 86
                                                    }
                                                });
                                            }
                                        }
                                        if ($secondaryNavbar.length){
                                            $secondaryNavbar.affix({
                                                offset: {
                                                    top: 86
                                                }
                                            });
                                        }
                                        if ($primaryNavbar.length){
                                            $primaryNavbar.affix({
                                                offset: {
                                                    top: 32
                                                }
                                            });
                                        }
                                    }
                                });
                        }
                    });
            },
            */

            closeAlert: function () {
                var that = this;
                /* old sticky header
                var alertheight = parseFloat($('.page-notification').outerHeight()).toFixed(0);
                var mobileHeaderHeight = parseFloat($('.mobile-header').outerHeight()).toFixed(0);
                var navbarHeight = parseFloat($('.primary-navbar').outerHeight()).toFixed(0);
                 var $primaryNavbar = $('body:not(.marketplace-page, .page-clientarea) .primary-navbar, .page-filename-submitticket.page-notlogged .primary-navbar');
                 var topBanner = $('.top-banner');

                 var $secondaryNavbar = $('body:not(.page-order, .page-clientarea) .secondary-navbar'),
                $secondaryNavbarCa = $('body.page-clientarea .secondary-navbar'),
                $mobileHeader = $('.mobile-header'),
                promoBanner = $('.promo-banner');
                if ($('.page-notification').outerHeight() !== null) {

                    if ($('.section-anchor').length){
                        if (window.matchMedia("(min-width: 991px)").matches) {
                            $('html, body').animate({
                                scrollTop: window.scrollY + parseInt(alertheight),
                            }),500;
                        }
                    }
                    if ($('.section-anchor').length){
                        $('.section-anchor').each(function(){
                            var that = $(this);
                            var navbarFirstHeight = parseFloat($('.primary-navbar').outerHeight()).toFixed(0);
                            var marginTop = $(this).css('margin-top')
                            var marginBottom = $(this).css('margin-bottom')
            
                            if (window.matchMedia("(max-width: 991px)").matches) {
                                navbarFirstHeight = parseFloat($('.mobile-header').outerHeight()).toFixed(0);
                            }
            
                            marginTop = parseInt(marginTop) + parseInt(alertheight);
                            marginBottom = parseInt(marginBottom) - parseInt(alertheight);
            
                            that.css('margin-top', marginTop+'px');
                            that.css('margin-bottom', marginBottom+'px');
                        })
                    }
                    enquire.register("screen and (min-width: 992px)", {
                        match: function () {
                            $('.page-wrapper').animate({
                                'margin-top': parseInt(navbarHeight)
                            }, 500);
                            $('.promo-banner').animate({
                                'margin-top': parseInt(navbarHeight),
                                'margin-bottom': - parseInt(navbarHeight),
                            }, 500);
                            $('.page-header').animate({
                                'top': 0
                            }, 500);
                            if($primaryNavbar.hasClass("affix-top")) {
                                $primaryNavbar.animate({
                                    'top': 64
                                }, 500);
                            }
                            else {
                                $primaryNavbar.animate({
                                    'top': 0
                                }, 500);
                            }
                            $('.page-notification').animate({
                                'top': -alertheight
                            }, 500);
                            $('.secondary-navbar').animate({
                                'top': 0
                            }, 500);
                            $('#category-sidebar').animate({
                                'padding-top': 0
                            });
                            $('#category-sidebar .filter:last-of-type').animate({
                                'margin-bottom': 16
                            });
                            $('#order-cart-summary').trigger("sticky_kit:detach").addClass('is-sticky');
                            $('#order-cart-summary').animate({
                                'top': 16
                            }, 0);
                            },
                    });
                    enquire.register("screen and (max-width: 991.98px)", {
                        match: function () {
                            $('.page-wrapper').animate({
                                'margin-top': mobileHeaderHeight
                            }, 500);
                            $('.promo-banner').animate({
                                'margin-top':  mobileHeaderHeight,
                                'margin-bottom': -  mobileHeaderHeight
                            }, 500);
                            // $('.mobile-header').animate({
                            //     'top': 0
                            // }, 500);

                            if ($('.mobile-header').hasClass('affix-top')) {
                                $('.mobile-header').animate({ 'top': 32 }, 500);
                            } else {
                                $('.mobile-header').animate({ 'top': 0 }, 500);
                            }

                            $('.page-notification').animate({
                                'top': -alertheight
                            }, 500);
                            $('.page-header').animate({
                                'padding-top': 32
                            }, 500);
                            $('#category-sidebar').animate({
                                'padding-top': 0
                            });
                            $('#category-sidebar .filter:last-of-type').animate({
                                'margin-bottom': 16
                            });
                            $('.secondary-navbar .dropdown-mobile .mobile-content').css({'top': 108});
                        }
                    });
                    enquire.register("screen and (min-width: 1200px)", {
                        match: function () {
                            $(window).off('.affix')
                            $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                            $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                            $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                            $primaryNavbar.removeData('bs.affix').removeClass('affix');
                            $mobileHeader.removeData('bs.affix').removeClass('affix');
                            if ($secondaryNavbarCa.length){
                                if (promoBanner.length){
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 250
                                        }
                                    });
                                }
                                else{
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 205
                                        }
                                    });
                                }
                            }
                            $secondaryNavbar.affix({
                                offset: {
                                    top: 205
                                }
                            });
                            $primaryNavbar.affix({
                                offset: {
                                    top: 64
                                }
                            });
                        }
                    });
                    enquire.register("screen and (min-width: 992px) and (max-width: 1200px)", {
                        match: function () {
                            $(window).off('.affix')
                            $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                            $secondaryNavbarCa.removeData('bs.affix').removeClass('affix affix-top');
                            $secondaryNavbar.removeData('bs.affix').removeClass('affix affix-top');
                            $primaryNavbar.removeData('bs.affix').removeClass('affix');
                            $mobileHeader.removeData('bs.affix').removeClass('affix');
                            if ($secondaryNavbarCa.length){
                                if (promoBanner.length){
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 194
                                        }
                                    });
                                }
                                else{
                                    $secondaryNavbarCa.affix({
                                        offset: {
                                            top: 116
                                        }
                                    });
                                }
                            }
                            $secondaryNavbar.affix({
                                offset: {
                                    top: 116
                                }
                            });
                            $primaryNavbar.affix({
                                offset: {
                                    top: 64
                                }
                            });
                        }
                    });
                }

                setTimeout(function () {
                    $('.page-header').css('top', '');
                    $('.page-wrapper').css('margin-top', '');
                    $('.promo-banner').css('margin-top','');
                    $('.promo-banner').css('margin-bottom','');
                    if($('.mobile-header').hasClass('affix')) {
                        $('.mobile-header').css('top', '0');
                        $(window).trigger('scroll');
                    }
                    else {
                        $('.mobile-header').css('top', '');
                        $(window).trigger('scroll');
                    }
                    topBanner.css({ position: 'relative', top: 0 });
                    that.removeAlert();
                }, 500);
                */
                var $notification = $('.page-notification');
                this.unbindScrollHide();
                $notification.removeClass('is-visible');
                $('body').removeClass('mg-has-notification');
                document.documentElement.style.removeProperty('--mg-notif-h');
                $(window).off('resize.mgNotifHeader');
                setTimeout(function () {
                    that.removeAlert();
                that.setCookie();
                }, 300);
            },
            setCookie: function () {
                $.getJSON("/products/build/assets/json/notification.json?v="+Math.random(), function (data) {
                    var
                        id = data.id || 1,
                        time = data['cookie-time'] || 30;

                    Cookies.set('siteAlert', id, {
                        expires: time
                    });
                });
            },
            removeAlert: function () {
                this.unbindScrollHide();
                $('.page-notification').remove();
                $('body').removeClass('scrolled-top mg-has-notification');
                document.documentElement.style.removeProperty('--mg-notif-h');
                $(window).off('resize.mgNotifHeader');
            }
        }

        multiAlert.init();

        enquire.register("screen and (min-width: 992px)", {
            match: function () {
                $(window).on('scroll', function () {
                    if($('.page-navbar .dropdown').hasClass('open')) {
                        $('.page-navbar .dropdown.open .dropdown-toggle').dropdown('toggle');
                    }
                });
            }
        });

        $(document).trigger('scripts/app/finished');
    });
    enquire.register('screen and (max-width: 579px)', {
		match: function () {
			$('.sitemap-links h6 > a').unbind('click').on('click', function (e) {
				e.preventDefault();

				var
					$this = $(this),
					$parent = $this.parent(),
					$nextParent = $parent.parent();

				if ($nextParent.hasClass('active')) {
					$nextParent.removeClass('active');
					$parent.siblings('ul').slideUp();

				} else {
					$this.closest('.footer-sitemap').find('.active').removeClass('active').children('ul').slideUp();
					$nextParent.addClass('active');
					$parent.siblings('ul').slideDown();
				}
			});
		},
		unmatch: function () {
			$('.sitemap-links h6 > a').on('click', function(e){
				e.preventDefault();

				var link = $(this).prop('href');
				if (link != "#"){
					window.location.href = link;
				}
				
			})
		}
	});

	enquire.register('screen and (min-width: 580px)', {
		match: function () {
			$('.sitemap-links h6 > a').on('click', function(e){
				e.preventDefault();

				var link = $(this).prop('href');
				if (link != ""){
					window.location.href = link;
				}
				
			})
		},
		unmatch: function () {
			$('.sitemap-links h6 > a').unbind('click').on('click', function (e) {
				e.preventDefault();
				var
					$this = $(this),
					$parent = $this.parent(),
					$nextParent = $parent.parent();
				if ($nextParent.hasClass('active')) {
					$nextParent.removeClass('active');
					$parent.siblings('ul').slideUp();
				} else {
					$this.closest('.footer-sitemap').find('.active').removeClass('active').children('ul').slideUp();
					$nextParent.addClass('active');
					$parent.siblings('ul').slideDown();
				}
			});
			
		}
	});
    
    enquire.register("screen and (max-width: 768px)", {
        match: function () {
            $(document).on('click', '.paginate_button', function () {
                 $('html, body').animate({
                        scrollTop: 0
                }, 0);
            });
        }
    });

    $(document).ready(function() {
        var $topBanner = $(".top-banner");
        var $toggler = $(".top-banner .top-banner-dropdown-icon");
        var $dropdown = $(".top-banner-dropdown");

        if ($topBanner.length && $dropdown.length && $toggler.length) {

            $toggler.on("click", function(e) {
                e.preventDefault();
                $dropdown.toggleClass("dropdown-open");
                $toggler.toggleClass("rotate");
                e.stopPropagation();
            });
            
            $topBanner.on("click", function(e) {
                if (!$(e.target).closest($dropdown).length && !$(e.target).closest($toggler).length) {
                    e.preventDefault();
                    $dropdown.toggleClass("dropdown-open");
                    $toggler.toggleClass("rotate");
                }
            });

            $(document).on("click", function(e) {
                if (!$(e.target).closest($dropdown).length && !$(e.target).closest($topBanner).length) {
                    $dropdown.removeClass("dropdown-open");
                    $toggler.removeClass("rotate");
                }
            });

        }
    });

$(function () {
        var $mobileHeader = $('.mobile-header');
  if (!$mobileHeader.length) return;

  function setHeaderTop() {
    var scrolled = $(window).scrollTop() > 32;
    $('body').toggleClass('mg-header-scrolled', scrolled);
    if (scrolled) {
            $mobileHeader.css('top', '0px');
        } else {
            $mobileHeader.css('top', '');
        }
  }

  setHeaderTop();

  $(window).on('scroll', setHeaderTop);
    });

$(function () {
  var $ecoBanner = $('.top-banner');
  if (!$ecoBanner.length) return;

  function setEcoHeight() {
    document.documentElement.style.setProperty('--mg-eco-h', Math.round($ecoBanner.outerHeight() || 0) + 'px');
  }

  setEcoHeight();

  $(window).on('resize', setEcoHeight);
});


})(jQuery, document, window, Mobile, Hammer, Navigation, Scrollbar, Fingerprint2, enquire);